import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ChatFormTypes } from "../../../../Components/Result/ChatForm/ChatForm";
import { getUserChatsActions } from "../getUserChats/getUserChats";
import { GetUserChatsDataTypes } from "../../../../Schema/getUserChats.types";
import { setChatMessages } from "../../subService/subServiceChats";
import { resetFiles } from "../../files/uploadedFiles/uploadedFiles";

export type PostUserServiceChatLoadAction = {
  type: string;
  payload: ChatFormTypes;
};

export type PostUserServiceChatData = {
  data: {
    data: GetUserChatsDataTypes;
    message_count: number;
    message_limit: number;
  };
};

const PostUserServiceChat = new ReduxFetchState<
  PostUserServiceChatData | null,
  ChatFormTypes,
  any
>("postUserServiceChat");

export function* watchPostUserServiceChat(
  action: PostUserServiceChatLoadAction,
) {
  try {
    const { id, file_ids, question, subServiceId, reset } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: PostUserServiceChatData = yield axios({
      url: `/api/v1/ai/user-sub-service/${id}/chat`,
      method: "POST",
      headers: {
        lang,
      },
      data: { question, file_ids },
    });

    yield put(PostUserServiceChat.actions.loadSuccess({ data: data.data }));
    yield put(getUserChatsActions.loadSuccess(null));
    if (subServiceId && data.data) {
      yield put(setChatMessages({ subServiceId, messages: data.data.data }));
      reset && reset();
      yield put(resetFiles());
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(PostUserServiceChat.actions.loadFailure(e.message));
  }
}

export function* postUserServiceChatSagas() {
  yield takeEvery(
    PostUserServiceChat.actionTypes.load,
    watchPostUserServiceChat,
  );
}

export function usePostUserServiceChat() {
  const { loading, data, ...postUserServiceChatState } = useAppSelector(
    (state) => state.postUserServiceChat,
  );
  const dispatch = useAppDispatch();

  const dispatchPostUserServiceChat = useCallback(
    (data: ChatFormTypes) => {
      dispatch(PostUserServiceChat.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postUserServiceChatState,
    dispatchPostUserServiceChat,
    postUserServiceChatLoading: loading,
    postUserServiceChatData: data,
  };
}

export const {
  actionTypes: postUserServiceChatActionsTypes,
  actions: postUserServiceChatActions,
  reducer: postUserServiceChatReducer,
} = PostUserServiceChat;
